import { useSyncExternalStore } from 'react';

// Celular = por debajo del breakpoint `sm` de Tailwind. Se pregunta en `rem`,
// la misma unidad que usan las clases `sm:` (40rem = 640 px con la fuente por
// defecto), para que lo que decide JS y lo que decide CSS cambien en el mismo
// ancho aunque el usuario haya agrandado la fuente del navegador.
const SM_QUERY = '(min-width: 40rem)';

function hasMatchMedia(): boolean {
  return typeof window !== 'undefined' && typeof window.matchMedia === 'function';
}

function readIsPhone(): boolean {
  return hasMatchMedia() && !window.matchMedia(SM_QUERY).matches;
}

function subscribeToWidth(onChange: () => void): () => void {
  if (!hasMatchMedia()) return () => {};
  const list = window.matchMedia(SM_QUERY);
  list.addEventListener('change', onChange);
  return () => list.removeEventListener('change', onChange);
}

// Para lo que en el celular se arma distinto y no alcanza con ocultarlo por
// CSS: ítems que existen solo en el menú del celular o controles que ahí no
// deben quedar en el DOM. Se vuelve a evaluar si la ventana cruza el corte.
// Sin matchMedia se asume escritorio, que es la vista de siempre.
export function useIsPhone(): boolean {
  return useSyncExternalStore(subscribeToWidth, readIsPhone);
}
